import React from 'react';
import BlankSlate from '@99designs/react-components/components/BlankSlate';
import { FormattedMessage } from 'react-intl';

export default ({ design }) => {
    if (design.permission.canView || design.width) {
        return null;
    }

    return (
        <BlankSlate
            variations={['wide']}
            icon={design.isDeleted ? 'trash-2' : 'document-1'}
            message={design.isDeleted ? <FormattedMessage id="design_deleted_message" /> : ''}
        />
    );
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/BlankSlate.jsx